import React from "react";
import classNames from "classnames/bind";
import styles from "./CtaCard.module.scss";
import { CtaCardProps } from "./types";
import { PlusCircle } from "@phosphor-icons/react";
import { colours } from "../../constants/colours";

const cx = classNames.bind(styles);

const DefaultIcon = (
  <PlusCircle
    size={48}
    color={colours.navy["500"]}
    weight="light"
  />
);

// TODO: this component needs a prop cleanup
/**
 * a cta card to launch an action
 */
const CtaCard = ({
  title,
  onClick,
  phosphorIconComponent = DefaultIcon,
  isLoading = false,
  isSolo = false,
}: CtaCardProps) => {
  return (
    <>
      {isLoading ? (
        <button
          className={cx("container", "loading", { "container-solo": isSolo })}
        >
          <div className={cx("skeletons")}>
            <div
              className={cx("skeleton")}
              style={{ width: 32, height: 32, marginBottom: 8 }}
            />
            <div
              className={cx("skeleton")}
              style={{ width: 200 }}
            />
          </div>
        </button>
      ) : (
        <button
          className={cx("container", { "container-solo": isSolo })}
          onClick={onClick}
        >
          {phosphorIconComponent}
          <p className={cx("title")}>{title}</p>
        </button>
      )}
    </>
  );
};

export default CtaCard;
